import { render, staticRenderFns } from "./blob_overflow_menu.vue?vue&type=template&id=309a2a34"
import script from "./blob_overflow_menu.vue?vue&type=script&lang=js"
export * from "./blob_overflow_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports